import {ModuleRegistry, ReactLazyComponent} from 'react-module-container';
import {ICashierPaymentsProps} from 'cashier-payments-widget/dist/src/cashier-payments.d';

export interface ICashierLazyPaymentsProps extends ICashierPaymentsProps {
    manifest;
}

export default class CashierPaymentsLazyWidget extends (ReactLazyComponent as React.ComponentClass<ICashierLazyPaymentsProps>) {
    constructor(props) {
        super(props, props.manifest);
    }
}



// WEBPACK FOOTER //
// ./CashierPaymentsLazyWidget/CashierPaymentsLazyWidget.ts